import { rowSelectionFeature, rowSortingFeature, tableFeatures } from '@tanstack/react-table';

// single source of truth for the registered features: Table uses the runtime object with
// useTable, TableBodyRow uses TableFeatureSet to type the Row it receives
export const features = tableFeatures({ rowSelectionFeature, rowSortingFeature });

export type TableFeatureSet = typeof features;
